import {createApp, h} from 'vue';

//This allows us to bridge the gap between Expression Engine templates and Vue components
// Dynamic import function to load components on demand
const components = {
    'clinical-policies': () => import('./components/ClinicalPolicies.vue'),
    'go-for-care': () => import('./components/GoForCare.vue'),
    'plan-finder': () => import('./components/PlanFinder.vue'),
    'prior-auth-codes-table': () => import('./components/PriorAuthCodesTable.vue'),
    'prior-auth-search': () => import('./components/PriorAuthSearch.vue'),
    'prior-auth-search-results': () => import('./components/PriorAuthSearchResults.vue'),
    'tab-links': () => import('./components/TabLinks.vue'),
};

// Mount each Vue component dynamically
document.querySelectorAll('[vue-component]').forEach((el) => {
    const componentName = el.getAttribute('vue-component');
    const loadComponent = components[componentName];

    if (loadComponent) {
        loadComponent().then((componentModule) => {
            const component = componentModule.default;

            // Parse `data-tabs` attribute
            const props = {};
            const dataTabs = el.getAttribute('data-tabs');
            if (dataTabs) {
                try {
                    props.tabs = JSON.parse(dataTabs);
                } catch (e) {
                    console.error('Invalid JSON in data-tabs for component "%s": %o', componentName, e);
                }
            }

            // Capture slot content from <template> tag
            const slotContent = {};
            el.querySelectorAll('template[slot]').forEach((template) => {
                const slotName = template.getAttribute('slot');
                slotContent[slotName] = () => h('div', {innerHTML: template.innerHTML});
            });

            // Create and mount the Vue app
            const app = createApp({
                render() {
                    return h(component, props, slotContent);
                },
            });
            app.mount(el);
        }).catch((error) => {
            console.error('Failed to load component "%s": %o', componentName, error);
        });
    } else {
        console.warn(`Component "${componentName}" not found.`);
    }
});